import { useBreakpoint } from 'hooks/useBreakpoint';
import styles from '../styles/pages/Other.module.css';
import { MobileLayout } from 'components/mobile/MobileLayout/MobileLayout';
import { useTranslation } from 'react-i18next';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import { Navigate, useNavigate } from 'react-router-dom';

export const Other = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isMobile } = useBreakpoint();

  if (!isMobile) {
    return <Navigate to="/" />;
  }
  const menuList = [
    { label: 'about_us_label', url: '/about-us' },
    { label: 'terms_and_conditions_label', url: '/terms-and-conditions' },
    { label: 'privacy_policy_label', url: '/privacy-policy' },
    { label: 'anti_money_laundering_label', url: '/anti-money-laundering' },
    { label: 'responsible_gaming_label', url: '/responsible-gaming' },
    { label: 'contact_label', url: '/contact' },
    { label: 'become_affiliate_label', url: '/become-affiliate' },
  ];

  return (
    <MobileLayout
      pageTitle={t('other_label')}
      title={
        <div className={styles.titleWrapper}>
          <ThemeIcon icon="info" alt="Info" variant="inline" />
          Info
        </div>
      }
    >
      {menuList.map((x) => (
        <div onClick={() => navigate(x.url)} className={styles.menuItem}>
          {t(x.label)}
          <div className={styles.chevronRight} />
        </div>
      ))}
    </MobileLayout>
  );
};
